function initialState() {
  return {
    stationKey: null,

    autoDj: {
      playlist: [],
      shuffle: false,
      stream: "",
    },

    current: {
      onAir: null,
      stream: "",
      track: "",
    },

    previewURL: null,
  }
}

let state = initialState()

export { initialState, state }
